import React, { FC, memo, useEffect, useMemo, useState } from 'react';
import Page from 'Component/common/udesk-qa-page-layout';
import { Tabs } from 'udesk-ui';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import Udesk from 'Udesk';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import './style.scss';
import UdeskLocales from 'UdeskLocales';
import { hasFeature } from 'src/util/permit';

const Template: FC<any> = memo((props) => {
    const TABS = useMemo(
        () => [
            {
                pathName: getCurrentRouteName('qaLanguageSettingVoice'),
                key: 'voice',
                text: /* 语音通话 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .voiceCall,
                id: 'voice',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingText'),
                key: 'text',
                text: /* 文本对话 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .textDialogue,
                id: 'text',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingTicket'),
                key: 'ticket',
                text: /* 工单 */ UdeskLocales['current'].pages.qaLanguageSetting.template.workOrder,
                id: 'ticket',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingVideo'),
                key: 'video',
                text: /* 视频通话 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .videoCall,
                id: 'video',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingWechatDialogue'),
                key: 'wechat-dialogue',
                text: /* 企微会话 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .enterpriseWeChatConversation,
                id: 'wechat-dialogue',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingWechatRadio'),
                key: 'wechat-radio',
                text: /* 企微语音 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .enterpriseMicroVoice,
                id: 'wechat-radio',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingEComment'),
                key: 'e-comment',
                text: /* 电商评论数据 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .ecommerceReviewData,
                id: 'e-comment',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingMComment'),
                key: 'm-comment',
                text: /* 社媒评论数据 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .socialMediaReviewData,
                id: 'm-comment',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingSurvey'),
                key: 'survey',
                text: /* 问卷 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .questionnaire,
                id: 'survey',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingFeishuGroup'),
                key: 'feishu-group',
                text: /* 飞书群聊 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .flyingBookGroupChat,
                id: 'feishu-group',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingEText'),
                key: 'eText',
                text: /* 电商文本对话 */UdeskLocales['current'].pages.qaLanguageSetting.template.ecommerceTextDialogue,
                id: 'eText',
            },
            {
                pathName: getCurrentRouteName('qaLanguageSettingTranslate'),
                key: 'translate',
                text: /* 翻译 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .translation,
                id: 'translate',
                hidden: !hasFeature('sys:largeAi:qa:translate'),
            },
        ],
        []
    );

    const [activeKey, setActiveKey] = useState<string>('voice');

    useEffect(() => {
        const currentPath = TABS.find(
            (item) => props.history.location.pathname.indexOf(item.id) >= 0
        );

        if (currentPath) {
            setActiveKey(currentPath.key as any);
        }
    }, [TABS, props.history.location]);

    const onAddTypeChange = (activeKey) => {
        setActiveKey(activeKey);
        const tab: any = TABS.find((t) => t.key === activeKey) ?? {};
        const routeOptions = {
            history: props.history,
            routeName: tab.pathName,
            pathParams: { taskId: props.match.params.taskId },
        };
        Udesk.ui.routing.transitionTo(routeOptions);
    };

    return (
        <Page
            pageBodyClassName="data-collection-add-page-index"
            title={
                /* 质检语言设置 */ UdeskLocales['current'].pages.qaLanguageSetting.template
                    .qualityInspectionLanguageSettings
            }
            padding={true}
        >
            <Tabs activeKey={activeKey} onChange={onAddTypeChange}>
                {props.routes.map((item, i) => {
                    const tab: any = TABS.filter((t) => !t.hidden).find(
                        (t) => t.pathName === item.name
                    );

                    if (!tab || tab.hidden) {
                        return null;
                    } else {
                        return (
                            <Tabs.TabPane tab={tab.text} key={tab.key}>
                                <SubRoutes key={i} route={item} />
                            </Tabs.TabPane>
                        );
                    }
                })}
            </Tabs>
        </Page>
    );
});

export default Template;
